import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=0c7b0284"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"
import style1 from "./ListPage.vue?vue&type=style&index=1&id=0c7b0284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports